import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  style: {"margin":"0"},
  class: "p-fluid p-grid p-formgrid"
}
const _hoisted_2 = {
  style: {"text-align":"left"},
  class: "p-field p-col-12 p-md-3"
}
const _hoisted_3 = { class: "m-0" }
const _hoisted_4 = {
  key: 0,
  class: "change-indicator"
}
const _hoisted_5 = {
  style: {"text-align":"left"},
  class: "p-field p-col-12 p-md-3"
}
const _hoisted_6 = { class: "m-0" }
const _hoisted_7 = {
  key: 0,
  class: "change-indicator"
}
const _hoisted_8 = {
  style: {"text-align":"left"},
  class: "p-field p-col-12 p-md-3"
}
const _hoisted_9 = { class: "m-0" }
const _hoisted_10 = {
  key: 0,
  class: "change-indicator"
}
const _hoisted_11 = {
  key: 0,
  style: {"text-align":"left"},
  class: "p-field p-col-12 p-md-3"
}
const _hoisted_12 = { class: "m-0" }
const _hoisted_13 = {
  key: 0,
  class: "change-indicator"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DSEDashboard = _resolveComponent("DSEDashboard")!
  const _component_p_panel = _resolveComponent("p-panel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createElementVNode("small", { class: "m-3" }, "Overall Performance", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("label", null, "Leads Generated", -1)),
        _createElementVNode("h1", _hoisted_3, [
          _createTextVNode(_toDisplayString((_ctx.report.mtdPerformance.leadsGenerated +  _ctx.dashboard.newLead)?.toLocaleString()) + " ", 1),
          ( _ctx.dashboard.newLead)
            ? (_openBlock(), _createElementBlock("small", _hoisted_4, "+" + _toDisplayString(_ctx.dashboard.newLead?.toLocaleString()), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[1] || (_cache[1] = _createElementVNode("label", null, "Converted Leads", -1)),
        _createElementVNode("h1", _hoisted_6, [
          _createTextVNode(_toDisplayString((_ctx.report.mtdPerformance.convertedLeads + _ctx.dashboard.convertLead)?.toLocaleString()) + " ", 1),
          ( _ctx.dashboard.convertLead)
            ? (_openBlock(), _createElementBlock("small", _hoisted_7, "+" + _toDisplayString(_ctx.dashboard.convertLead?.toLocaleString()), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[2] || (_cache[2] = _createElementVNode("label", null, "Revenue Generated", -1)),
        _createElementVNode("h1", _hoisted_9, [
          _createTextVNode(_toDisplayString(_ctx.formatToIndianNotation(_ctx.report.mtdPerformance.revenueGenerated +  _ctx.dashboard.revenueGenerated)) + " ", 1),
          ( _ctx.dashboard.revenueGenerated)
            ? (_openBlock(), _createElementBlock("small", _hoisted_10, "+" + _toDisplayString(_ctx.dashboard.revenueGenerated?.toLocaleString()), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.report.mtdPerformance.newCustomers)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _cache[3] || (_cache[3] = _createElementVNode("label", null, "New Customers", -1)),
            _createElementVNode("h1", _hoisted_12, [
              _createTextVNode(_toDisplayString((_ctx.report.mtdPerformance.newCustomers + _ctx.dashboard.newCustomer)?.toLocaleString()) + " ", 1),
              ( _ctx.dashboard.newCustomer)
                ? (_openBlock(), _createElementBlock("small", _hoisted_13, "+" + _toDisplayString(_ctx.dashboard.newCustomer?.toLocaleString()), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reports, (dash) => {
      return (_openBlock(), _createElementBlock("div", {
        key: dash.employee_username
      }, [
        _createVNode(_component_p_panel, {
          style: {"margin-top":"5px"},
          header: dash.employee_name,
          collapsed: "",
          toggleable: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DSEDashboard, {
              hide_plus: true,
              report: dash
            }, null, 8, ["report"])
          ]),
          _: 2
        }, 1032, ["header"])
      ]))
    }), 128))
  ], 64))
}